import { css } from "styled-components";

const BREAKPOINTS = {
  xxxxs: 250,
  xxxs: 300,
  xxs: 390,
  xs: 480,
  sm: 768,
  md: 992,
  lg: 1024,
  xl: 1200,
  xxl: 1600,
};

const hiddenxl = css`
  @media (max-width: ${BREAKPOINTS.xl}px) {
    display: none;
  }
`;

const hiddenlg = css`
  @media (max-width: ${BREAKPOINTS.lg}px) {
    display: none;
  }
`;

const hiddenmd = css`
  @media (max-width: ${BREAKPOINTS.md}px) {
    display: none;
  }
`;

const hiddensm = css`
  @media (max-width: ${BREAKPOINTS.sm}px) {
    display: none;
  }
`;

const hiddenxs = css`
  @media (max-width: ${BREAKPOINTS.xs}px) {
    display: none;
  }
`;

const desktop = css`
  display: none;
  @media (min-width: ${BREAKPOINTS.sm}px) {
    display: block;
  }
`;

const ipad = css`
  @media (min-width: ${BREAKPOINTS.md}px) {
    display: none;
  }
`;

const mobile = css`
  display: block;
  @media (min-width: ${BREAKPOINTS.sm}px) {
    display: none;
  }
`;

export {
  BREAKPOINTS,
  hiddenxl,
  hiddenlg,
  hiddenmd,
  hiddensm,
  hiddenxs,
  desktop,
  ipad,
  mobile,
};
